import { render, staticRenderFns } from "./domainCertificateModal.vue?vue&type=template&id=9ab76972&scoped=true&"
import script from "./domainCertificateModal.vue?vue&type=script&lang=js&"
export * from "./domainCertificateModal.vue?vue&type=script&lang=js&"
import style0 from "./domainCertificateModal.vue?vue&type=style&index=0&id=9ab76972&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab76972",
  null
  
)

export default component.exports